import React from 'react';
import PropTypes from 'prop-types';
import { useToast, ToastProvider, ToastContainer } from '@unite-us/app-components';

const toastTopStyle = {
  top: '-30px',
};

export const WithToast = (WrappedComponent) => {
  function WithToastComponent(props) {
    return (
      <ToastProvider>
        <>
          <div
            className="fixed z-notification inset-0 pointer-events-none flex flex-col items-center mt-auto"
            style={toastTopStyle}
          >
            <ToastContainer />
          </div>
          <ToastInner BaseComponent={WrappedComponent} {...props} />
        </>
      </ToastProvider>
    );
  }

  function ToastInner({ BaseComponent, ...props }) {
    const { addToast } = useToast();
    return <BaseComponent {...props} addToast={addToast} />;
  }

  ToastInner.propTypes = {
    BaseComponent: PropTypes.elementType.isRequired,
  };

  return WithToastComponent;
};
